<template>
  <div class="form-group field-certListBox">
    <label class="control-label" :for="certListBoxId">Выбрать сертификат</label>
    <select
      :id="certListBoxId"
      :class="selectClass"
      aria-invalid="false"
      size="4"
      v-model="selected"
      @change="emitSelection"
      @DOMSubtreeModified="emitSelection"
    >
      <option
        v-for="option in options"
        v-bind:key="option.thumbprint"
        :value="option.thumbprint"
      >
        {{ option.text }}
      </option>
    </select>
    <div class="help-block"></div>
    <div class="external-info" v-html="this.externalInfo"></div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';
import { CertificateObj } from '@/common/helpers/signer/certificates';
import { certificatesIterator } from '@/common/helpers/signer/certificatesIterator';
import { CertificatesStringConstructor } from '@/common/helpers/signer/certificatesStringConstructor';

export default {
  name: 'CertificatesListBox',

  props: {
    certListBoxId: {
      type: String,
      default: uuid()
    },

    externalInfo: {
      type: String,
      default: ''
    },

    selectClass: {
      type: String,
      default: ''
    },

    stringConstructor: {
      type: CertificatesStringConstructor,
      required: true
    },

    selectionBridge: {
      type: Function,
      default: () => () => 0
    }
  },

  data: () => ({
    selected: '',
    options: [],
    certificates: new Map()
  }),

  async mounted () {
    for await (const certificate of certificatesIterator()) {
      let certObj = new CertificateObj(certificate)
      let subjectName = await certObj.cert.SubjectName
      let algorithmName = await certObj.GetFriendlyName()
      let text = await certObj.GetCertString(subjectName, algorithmName)
      let thumbprint = await certificate.Thumbprint
      this.certificates.set(thumbprint, certificate)
      this.options.push({ thumbprint, text })
    }
  },

  methods: {
    emitSelection () {
      let certificate = this.certificates.get(this.selected)
      this.$emit('certificate-selected', certificate)
      this.selectionBridge(certificate)
    }
  }
}
</script>
